<template>
	<section class="main-content intro">
		<div class="row">
			<slot name="full-content">
				<div class="columns column12" :class="[content ? '' : 'align-center']">
					<div class="reverse-title">
						<h1>{{ title }}</h1>
						<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
					</div>
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
				<slot name="extra-heading" />
			</slot>
		</div>
		<slot name="bottom-content" />
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.reverse-title {
	display: flex;
	flex-flow: column-reverse wrap;
	width: 100%;
	max-width: 800px;

	h1 {
		max-width: 100%;
	}
}

.align-center {
	.reverse-title {
		margin: 0 auto;
	}
}

.main-content {
	position: relative;

	.row {
		position: relative;
		z-index: 2;
		justify-content: space-between;
	}

	:deep(p:first-child) {
		margin-top: 0;
	}
}

@media (max-width: 880px) {
	.column5 {
		width: 100%;
	}
}
</style>
